import React, {Component} from 'react';
import styled from 'styled-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import MetisMenu from 'react-metismenu';
import RouterLink from 'react-metismenu-router-link'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import 'font-awesome/css/font-awesome.css';
import {getAdministrationMenuAdminHtl} from './structure/AdministrationMenu';
import {getSparePartsDealerMenu, getSparePartsEditorMenu} from './structure/OrderMenu';
import {
    getTechDocDealerMenu,
    getTechDocEditorMenu
} from './structure/DocumentationMenu';
import {ClaimsMenuAdmin, ClaimsMenuEditor, getClaimsDealerMenu} from './structure/ClaimsMenu';
import {moduleRoles} from '../../../utils/roles';
import {PRIMARY_DARK_GREY, PRIMARY_WHITE} from '../../../theme/colors';

const Menu = styled.div`
    padding-top: 15px;
    width: 283px;
    transition: all 0.5s ease;
    direction: rtl;
`;
Menu.displayName = 'Menu';

const ScrollBarLeft = styled.div`
    direction: ltr;
    transition: all 0.5s ease;
`;
ScrollBarLeft.displayName = 'ScrollBarLeft';

const Wrapper = styled.div`
    ${props => props.sideBarShow ? 'margin-left: -280px' : 'margin-left: 0px'};
    width: 308px;
    height: 100%;
    display: flex;
    transition: all 0.5s ease;
    padding-left: 3px;
`;
Wrapper.displayName = 'Wrapper';

const ChevronCol = styled.div`
    border-right: 1px solid ${PRIMARY_DARK_GREY};
    width: 28px;
    padding-top: 50px;
    margin-left: 3px;
`;

const ChevronButton = styled.div`
    display: flex;
    flex-flow: column;
    justify-content: center;
    width: 25px;
    cursor: pointer;
    height: 50px;
    background-color: ${PRIMARY_WHITE};
    border: 1px solid ${PRIMARY_DARK_GREY};
    border-right: none;
    border-radius: 0.3em 0 0 0.3em;
    margin-left: 3px;
`;
ChevronCol.displayName = 'ChevronCol';

const ChevronIcon = styled(FontAwesomeIcon)`
    font-size: 20px;
    margin-left: 5px;
`;
ChevronIcon.displayName = 'ChevronIcon';

class SideMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {sideBarShow: false, sideBarContent: []};
    }

    componentDidMount() {
        this.createSideBarContent();
    }

    componentDidUpdate() {
        this.createSideBarContent();
    }

    handleChevronClick = e => {
        e.preventDefault();
        this.setState({sideBarShow: !this.state.sideBarShow});
    };

    createSideBarContent = () => {
        const {administration = false, order = false, documentation = false, ase = false, claims = false, roles} = this.props;
        let sideBarContent = [];
        if (administration && (moduleRoles.isAdmin(roles) || moduleRoles.isPowerUser(roles) || moduleRoles.isSGAdmin(roles))) {
            sideBarContent = getAdministrationMenuAdminHtl(roles);
        } else if (order && moduleRoles.isDealerOrder(roles)) {
            sideBarContent = getSparePartsDealerMenu(roles);
        } else if (order && !moduleRoles.isDealerOrder(roles) && (moduleRoles.isEditorOrder(roles) || moduleRoles.isSGEditorOrder(roles))) {
            sideBarContent = getSparePartsEditorMenu(roles);
        } else if (documentation && moduleRoles.isDealerDocumentation(roles)) {
            sideBarContent = getTechDocDealerMenu(roles);
        } else if (documentation && !moduleRoles.isDealerDocumentation(roles) && (moduleRoles.isEditorDocumentation(roles) || moduleRoles.isSGEditorDocumentation(roles))) {
            sideBarContent = getTechDocEditorMenu(roles);
        } else if (claims && moduleRoles.isDealerClaims(roles)) {
            sideBarContent = getClaimsDealerMenu(roles);
        } else if (claims && !moduleRoles.isDealerClaims(roles) && moduleRoles.isEditorClaims(roles)) {
            const exportMenu = moduleRoles.isAdminClaims(roles) ? ClaimsMenuAdmin : [];
            sideBarContent = [
                ...ClaimsMenuEditor,
                ...exportMenu
            ];
        }
        if (JSON.stringify(this.state.sideBarContent) !== JSON.stringify(sideBarContent)) {
            this.setState({sideBarContent});
        }
    };

    render() {
        return (
            <Wrapper id="leftMenuPrint" sideBarShow={this.state.sideBarShow}>
                <Menu>
                    <ScrollBarLeft>
                        <MetisMenu
                            content={this.state.sideBarContent}
                            LinkComponent={RouterLink}
                            useExternalReduxStore={this.props.store}
                        />
                    </ScrollBarLeft>
                </Menu>
                <ChevronCol>
                    <ChevronButton sideBarShow={this.state.sideBarShow} onClick={this.handleChevronClick}>
                        <ChevronIcon icon={this.state.sideBarShow ? 'chevron-right' : 'chevron-left'}/>
                    </ChevronButton>
                </ChevronCol>
            </Wrapper>
        );
    }
}

SideMenu.propTypes = {
    store: PropTypes.object.isRequired,
    administration: PropTypes.bool,
    order: PropTypes.bool,
    documentation: PropTypes.bool,
    claims: PropTypes.bool,
    roles: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    roles: state.profile.userDetail.roles,
});

export default connect(mapStateToProps, {})(SideMenu);
